import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logoCZ from './cz_flag.png';
import logoEN from './en_flag.png';
import logoTUL from './logo_tul_b.jpg';


export default class TopBar extends Component {


    static propTypes = {
        onClick: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired
    };

    render() {
    return (
        <div class="row" data-reactid=".0.1">
            <div className="col-md-2">
               <img alt="tul" src={ logoTUL } style={{
                    'width': '100%',
                    'paddingTop': 0,
                    'paddingBottom': 0
                }} /> 
            </div>
            <div className="col-md-8">
                <h1 id="maintitle">{this.props.title}</h1>
            </div>
            <div class="col-md-2">
                <div className="vcenter">
                  <img className="langIcon"
                        data-lang="cz"
                         onClick={this.props.onClick.bind(null, 'CZ')}
                         src={ logoCZ } 
                         alt="CZ"
                         />
                    <img className="langIcon"
                        data-lang="en"
                         onClick={this.props.onClick.bind(null, 'EN')}
                         src={ logoEN } 
                         alt="EN"
                         />
                </div>
            </div>
        </div>


    );
  }
}
